var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPortraitLandscape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 81.92 71.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".bb000ec3-fe06-4a62-9efb-112d2f80782f{fill:#1bc6c1;}.a89a17b0-c6ad-46be-acef-ef0be5459dde{fill:#b5b5b5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a28b7a99-9e60-4736-bb44-1a76c60aa01e",
    "data-name": "Laag 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b7c2be8c-961f-4fab-b948-c866510381a1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bb000ec3-fe06-4a62-9efb-112d2f80782f",
    d: "M73.42,71.73H18.7a8.53,8.53,0,0,1-8.5-8.5v-22a8.51,8.51,0,0,1,8.5-8.5H73.42a8.51,8.51,0,0,1,8.5,8.5v22A8.51,8.51,0,0,1,73.42,71.73Zm-54.72-37a6.51,6.51,0,0,0-6.5,6.5v22a6.51,6.51,0,0,0,6.5,6.5H73.42a6.51,6.51,0,0,0,6.5-6.5v-22a6.5,6.5,0,0,0-6.5-6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bb000ec3-fe06-4a62-9efb-112d2f80782f",
    d: "M8.5,71.72A8.51,8.51,0,0,1,0,63.22V8.5A8.51,8.51,0,0,1,8.5,0h22A8.51,8.51,0,0,1,39,8.5V28.8H37V8.5A6.51,6.51,0,0,0,30.5,2H8.5A6.51,6.51,0,0,0,2,8.5V63.22a6.51,6.51,0,0,0,6.5,6.5h.3a5.4,5.4,0,0,0,2.88,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a89a17b0-c6ad-46be-acef-ef0be5459dde",
    d: "M71.81,19.56l-2.35,2.5C68.44,7.5,61.49.11,48.75.11v2c11.62,0,17.74,6.54,18.71,19.94L65,19.76l.09,2.88,3.49,3.29,3.29-3.49Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortraitLandscape);
export default __webpack_public_path__ + "static/media/portrait-landscape.72df1ff99d20f2746a9e497ff4280a2e.svg";
export { ForwardRef as ReactComponent };